import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "../../api/axiosConfig";
import { checkLicenseCode } from "../../redux/actions/Firebase/redeemCodeAction";
import "./LicenseScreenModal.css";
import signOut from "../../functions/userIdentity/signOut";
import { getLatestTaskList } from "../../redux/actions/Firebase/getLatestTaskListAction";
import { useIsMobile } from "../../functions/deviceIdentity/getDeviceType";

const LicensingModal = (props) => {
    const { onOpen, onClose } = props;
    const modalRef = useRef();
    const isMobile = useIsMobile();
    const userDetails = useSelector((state) => state.userDetails.user);
    const [code, setCode] = useState("");
    const [agreeMarketing, setAgreeMarketing] = useState(false);
    const dispatch = useDispatch();
    const licenseState = useSelector((state) => state.license);

    if (licenseState.licenseValid) {
        onClose();
    }

    const error = licenseState.error;

    const handleKeyDown = (event) => {
        if (event.keyCode === 27) {
            event.preventDefault(); // Prevent default modal closing behavior
        }
    };

    useEffect(() => {
        if (onOpen) {
            modalRef.current?.showModal();
        } else {
            modalRef.current?.close();
        }
    }, [onOpen]); // Update on prop changes and potentially state change

    const redeemCode = async () => {
        const data = {
            code,
            agreeMarketing,
        };
        console.log("Dispatching checkLicenseCode");
        dispatch(checkLicenseCode(data));
        dispatch(getLatestTaskList());
    };

    //useEffect(() => {
    //    console.log("licenseState changed:", licenseState); // Debugging log
    //}, [licenseState]); // Re-render on licenseState change

    return (
        <dialog
            className="gt-modal gt-modal--licensing"
            aria-labelledby="modal-title"
            ref={modalRef}
            onKeyDown={handleKeyDown}
        >
            <div className="gt-modal-content">
                <div className="gt-modal-content__body">
                    <svg xmlns="http://www.w3.org/2000/svg">
                        <use xlinkHref="#globaltasks-svg-license"></use>
                    </svg>

                    <h2 id="modal-title">Redeem code</h2>
                    <p>To continue to use Global Tasks, you need to redeem a code</p>
                    {userDetails ? (
                        <p>Hello {userDetails.name}! ({userDetails.email})</p>
                    ) : (
                        <p>Loading user details...</p>
                    )}
                    <a href="#" onClick={signOut}>
                        log out
                    </a>

                    <div className="gw-form-fieldset-item">
                        <input
                            type="text"
                            className="gw-input"
                            placeholder="Paste your code here..."
                            id="license-key"
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                        />
                        {error && (
                            <div className="error-body">
                                <label className="gw-checkbox__input-label error-message"
                                    style={{color: "red"} }>
                                    Oops something went wrong: {error}
                                </label>
                                <label className="gw-checkbox__input-label error-message"
                                    style={{ color: "red" }}>
                                    Please try a different code or 
                                </label>
                                <button
                                    className="support-hyperlink"
                                    type="button"
                                    /*className="gw-button gw-button--link"*/
                                    onClick={() =>
                                        window.open(
                                            "https://support.texthelp.com/help/globaltasks",
                                            "_blank",
                                            "noopener,noreferrer"
                                        )
                                    }
                                >contact support</button>
                            </div>
                        )}
                    </div>

                    <div className="gw-checkbox">
                        <input
                            id="agree-contact"
                            type="checkbox"
                            className="gw-checkbox__input"
                            name="agree-contact"
                            checked={agreeMarketing}
                            onChange={(e) => setAgreeMarketing((state) => !state)}
                        />
                        <label htmlFor="agree-contact" className="gw-checkbox__input-label">
                            I agree for Everway to contact me from time to time about
                            products and services that they think would interest me.
                        </label>
                    </div>

                    <div className="gw-group gw-group--space-between">
                        <button
                            className="gw-button gw-button--link"
                            style={{fontWeight: "normal"} }
                            type="button"
                            /*className="gw-button gw-button--link"*/
                            onClick={() =>
                                window.open(
                                    "https://support.texthelp.com/help/globaltasks",
                                    "_blank",
                                    "noopener,noreferrer"
                                )
                            }
                        >
                            What if I don’t have a code to redeem?
                        </button>
                        <button
                            type="button"
                            className="gw-button gw-button--primary"
                            onClick={redeemCode}
                        >
                            Let's Go!
                        </button>
                    </div>
                </div>
            </div>
        </dialog>
    );
};

export default LicensingModal;
